import { trackingEvents } from 'modules/core/lib/Tracking'
import { dateBackendDateTimeToBackend } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

import AccountOnboardingLink from 'modules/banking/components/AccountOnboarding/Link'
import BaseNotification from 'modules/expenses/components/_Notification/Base'

interface Props {
  onboardingDeadline: string
}

const DeadlineNotification = ({ onboardingDeadline }: Props) => (
  <BaseNotification
    type="warning"
    compact
    description={i18n.t('expenses_v2.alerts.deadline_account.description', {
      current_deadline: dateBackendDateTimeToBackend(onboardingDeadline),
    })}
    link={
      <AccountOnboardingLink
        label={i18n.t('expenses_v2.alerts.deadline_account.go_to_account_settings')}
        source="expenses"
        trackingEvent={trackingEvents.factorialTip.clickedTheTooltipLink}
      />
    }
  />
)

export default DeadlineNotification
